<div
  class="col-picker"
  [colorPicker]="value ?? ''"
  (colorPickerChange)="(value)"
  [style.background]="value"
  [cpPresetColors]="presetColors"
  cpPresetLabel=""
  (colorPickerChange)="valueChange.emit($event)"
></div>
